import React,  { useEffect }  from "react";
import { Link, Redirect } from "react-router-dom";
import userStore from "../../../Stores/User";
import { observer } from "mobx-react";

const Welcome = observer(() => {
  const { user, creditsHd } = userStore;

  useEffect(() => {
    if (user) {
      console.log(user)
      console.log('redirecting...')
      return <Redirect to={`/`} />;
    }
  }, [userStore.user]);

  if (userStore.user){
    return <Redirect to={`/onboarding/HowToClip`} />;
  }
  return (
    <div className="center-static">
      <h1 className="headline">
        👋🏼 Welcome! <br></br> Are you new?
      </h1>
      <div className="cta-div" style={{ position: "static" }}>
        <Link className="cta-button" to="CreateAccount?app=extension">
          Yes
        </Link>
        <Link className="sub-cta-link" to="/signin?source=onboarding_existing&redirected_from=onboarding">
          No, I already have an account
        </Link>
      </div>
    </div>
  );
});

export default Welcome;
